import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { eramanCMSApi } from "~/Services";
export interface EramanRegister {
  id: number;
  signUp: string;
  signUpDescription: string;
  username: string;
  title: string;
  icAnndPassport: string;
  nationality: string;
  nationalityMalaysian: string;
  nationalityOthers: string;
  passportNumber: string;
  field_nric_data_field: string; // ✅ Added here
  mobileNumber: string;
  emailAddress: string;
  agree: string;
  agreeEmail: string;
  agreeSms: string;
  password: string;
  confirmPassword: string;
  passwordCondition: string;
  termsAndConditions: string;
  asterisktext: string;
  field_login_text_for_register: string;
  field_eraman_user_text: string;
  register: string;
  publish: boolean;
  createdAt: string;
  updatedAt: string;
  field_login_cover: string;
  field_whiteheart_image: string;
  field_redheart_image: string;
  field_awardscover_image: string;
  field_elogo_image: string;
  field_ecard_image: string;
  field_logo_new_image: string;
  field_empty_wishlist_image: string;
  field_download_image: string;
  field_star_rate_image: string;
}

export interface EramanSignIn {
  id: number;
  title: string;
  field_register_text: string;
  field_key: string;
  field_contine_with_google_text: string;
  field_continue_with_facebook: string;
  field_login_text_for_register: string;
  field_email_username_text: string;
  field_eraman_user_text: string;
  field_password_text: string;
  field_forgot_password_text: string;
  field_sign_up_description: string;
  field_sign_uptext: string;
  nricNumber: string; // ✅ Added here
  field_eye_icon: string;
  field_icon_facebook: string;
  field_icon_image: string;
}

interface EpcMembership {
  nid: number;
  title: string;
  field_country_text: string;
  field_country_text_ms: string;
  field_country_text_zh: string;
  field_date_of_birth_text: string;
  field_date_of_birth_text_ms: string;
  field_date_of_birth_text_zh: string;
  field_edit_epc_details_text: string;
  field_edit_epc_details_ms: string;
  field_edit_epc_details_zh: string;
  field_email: string;
  field_email_text_ms: string;
  field_email_text_zh: string;
  preferredCard: string;
  priorityCard: string;
  classicCard: string;
  body: string;
  field_epc_description_ms: string;
  field_epc_description_zh: string;
  field_epc_id: string;
  field_epc_id_text_ms: string;
  field_epc_id_text_zh: string;
  field_epc_member_description: string;
  field_epc_member_description_ms: string;
  field_epc_member_description_zh: string;
  field_epc_card_heading_en: string;
  field_epc_card_heading_ms: string;
  field_epc_card_heading_zh: string;
  field_epc_type: string;
  field_epc_type_ms: string;
  field_epc_type_zh: string;
  field_expiry_date_text: string;
  field_expiry_date_text_ms: string;
  field_expiry_date_text_zh: string;
  field_full_name: string;
  field_full_name_ms: string;
  field_full_name_zh: string;
  field_gender_text: string;
  field_gender_text_ms: string;
  field_gender_text_zh: string;
  field_key: string;
  field_mobile_number: string;
  field_mobile_number_text_ms: string;
  field_mobile_number_text_zh: string;
  field_nationality: string;
  field_nationality_text_ms: string;
  field_nationality_text_zh: string;
  field_nric_text: string;
  field_nric_text_ms: string;
  field_nric_text_zh: string;
  field_passport_text: string;
  field_password_text_ms: string;
  field_passport_number_text_zh: string;
  field_promotion_material: string;
  field_promotion_material_ms: string;
  field_promotion_material_zh: string;
  field_state_text: string;
  field_state_text_ms: string;
  field_state_text_zh: string;
  title_text_En: string;
  field_title_text_ms: string;
  field_title_text_zh: string;
  field_upgrade_text: string;
  field_upgrade_text_ms: string;
  field_upgrade_text_zh: string;
}

interface EramanOTP {
  id: string;
  title: string;
  field_sign_uptext: string;
  field_sign_up_description: string;
  field_repeat_again: string;
  field_otp_request_text: string;
  field_upgrade_text: string;
}

interface EramanUserProfile {
  id: string;
  title: string;
  field_name_text: string;
  field_name_text_ms: string;
  field_name_text_zh: string;
  field_username_text: string;
  field_user_name_ms: string;
  field_user_name_zh: string;
  field_new_password_text: string;
  field_new_password_text_ms: string;
  field_new_password_text_zh: string;
  field_confirm_password: string;
  field_confirm_password_text_ms: string;
  field_confirm_password_zh: string;
  field_password_conditions: string;
  field_password_conditions_ms: string;
  field_password_conditions_zh: string;
  field_email_text: string;
  field_email_text_ms: string;
  field_email_text_zh: string;
  field_epc_id_text: string;
  field_epc_id_text_ms: string;
  field_epc_id_text_zh: string;
  field_update_text: string;
  field_update_ms: string;
  field_update_zh: string;
}

interface EramanProductReview {
  id: string;
  title: string;
  field_heading_text: string;
  field_review_title: string;
  field_attachments: string;
  field_browse_files: string;
  field_file_extensions_allowed: string;
  field_description: string;
  field_submit_button: string;
}

interface EramanResetPassword {
  id: string;
  title: string;
  createpassword: string;
  confirmpassword: string;
  resetpassword_description: string;
  image: string;
  submitbutton: string;
}

interface EPCRenewal {
  id: string;
  title: string;
  renew_epc_card_heading: string;
  field_renew_epc_description: string;
  apply_renewal_button: string;
  field_renew_text_withoutbutton: string;
}

const fetchData = async <T>(url: string): Promise<T> => {
  const response = await eramanCMSApi.get<T>(url);
  console.log("fetchData", response, url);
  return response.data;
};

export const createDataHook =
  <T>(key: string, url: string) =>
  (
    options?: UseQueryOptions<T, DefaultError, T, QueryKey>,
    queryClient?: QueryClient
  ): UseQueryResult<T, DefaultError> => {
    return useQuery<T, DefaultError, T, QueryKey>(
      {
        queryKey: [key],
        enabled: false,
        queryFn: () => fetchData<T>(url),
        refetchOnWindowFocus: false,
        ...options,
      },
      queryClient
    );
  };

export const createDataHooksForPages =
  <T>(key: string, getUrl: (listId: string) => string) =>
  (
    listId: string,
    options?: UseQueryOptions<T, DefaultError, T, QueryKey>,
    queryClient?: QueryClient
  ): UseQueryResult<T, DefaultError> => {
    return useQuery<T, DefaultError, T, QueryKey>(
      {
        queryKey: [key, listId],
        enabled: false,
        queryFn: () => fetchData<T>(getUrl(listId)),
        refetchOnWindowFocus: false,
        ...options,
      },
      queryClient
    );
  };

const useEramanRegister = createDataHook<EramanRegister[]>("eramanRegister", `/api/signup/all-fields`);

const useEramanSignIn = createDataHook<EramanSignIn[]>("eramanSignIn", `/api/login-page-view-data/all-fields?key=Login`);

const useEramanForgotPassword = createDataHook<EramanSignIn[]>(
  "eramanForgotPassword",
  `/api/login-page-view-data/all-fields?key=ForgotPassword`
);

const useEpcMembership = createDataHook<EpcMembership[]>("epcMembership", `/api/epc-detailsandcard`);

const useEramanOTP = createDataHook<EramanOTP[]>("eramanOTP", `/api/registration-otp-page-data-list/all-fields`);

const useEramanUserProfile = createDataHook<EramanUserProfile[]>(
  "eramanUserProfile",
  `/api/user-profile-view-data-list/all-fields`
);

const useEramanProductReview = createDataHook<EramanProductReview[]>(
  "eramanProductReview",
  `/api/product-review-page-data-list/all-fields`
);

const useEramanResetPassword = createDataHook<EramanResetPassword[]>(
  "eramanResetPassword",
  `/api/reset-password-data-list/all-fields`
);

const useEPCRenewal = createDataHook<EPCRenewal[]>("epcRenewal", `/api/epc-renewal-data-list/all-fields`);

export {
  useEpcMembership,
  useEPCRenewal,
  useEramanForgotPassword,
  useEramanOTP,
  useEramanProductReview,
  useEramanRegister,
  useEramanResetPassword,
  useEramanSignIn,
  useEramanUserProfile,
};
